"use client";

import Link from "next/link";
import type { ReactNode } from "react";

export type PublicBookingAction =
  | { type: "navigate"; href: string }
  | { type: "focus"; targetId: string };

export const DEFAULT_BOOKING_ACTION: PublicBookingAction = {
  type: "navigate",
  href: "/slobodni-termini",
};

export function focusBookingTarget(targetId: string) {
  const target = document.getElementById(targetId);
  if (!target) return;

  target.scrollIntoView({ behavior: "instant", block: "start" });
  target.focus({ preventScroll: true });
}

export function PublicBookingCta({
  action = DEFAULT_BOOKING_ACTION,
  className,
  children,
  onClick,
  onFocusRequest = focusBookingTarget,
}: {
  action?: PublicBookingAction;
  className?: string;
  children: ReactNode;
  onClick?: () => void;
  onFocusRequest?: (targetId: string) => void;
}) {
  if (action.type === "navigate") {
    return (
      <Link href={action.href} className={className} onClick={onClick}>
        {children}
      </Link>
    );
  }

  return (
    <button
      type="button"
      className={className}
      onClick={() => {
        onClick?.();
        onFocusRequest(action.targetId);
      }}
    >
      {children}
    </button>
  );
}
